import { useTranslation } from "react-i18next";


const SafetySection = () => {
  const { t } = useTranslation("safety");
  return (
    <div className="relative">
      {/* Hero Section */}
      <div className="relative h-[384px] md:h-[384px] lg:h-[350px]">
        <img
          src="/assets/servicesbg.svg"
          className="w-full h-full object-cover"
          alt="background animation"
        />
        <div className="absolute inset-0 bg-[#00000099]"></div>
        <img
          src="/assets/ellipse.svg"
          className="absolute bottom-64 left-1/2 transform -translate-x-1/2 translate-y-1/2"
          alt="ellipse decoration"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-2 md:px-4 ">
          {/* Welcome Text */}
          <div className="title-small text-[#05897E] py-2 px-4 rounded-full mb-4 border border-[#FFFFFF33]">
            {t("solution_section_title")}
          </div>
          {/* Main Heading */}
          <h1 className="web-heading-main mb-4">{t("safety_management_title")}</h1>
          {/* Description */}
          <p className="text-color body-large-30 mb-6 md:text-xl max-w-5xl">
            {t("safety_management_description")}
          </p>
        </div>
      </div>


      {/* Content Section */}
      <div className="relative text-white px-4 py-8 max-w-7xl mx-auto mb-10">
        {/* Hero Content */}
        <div className="flex flex-col md:flex-row items-center justify-center">
          <div className="w-full space-y-6">
            {/* Key Questions Section */}
            <h2 className="web-heading-main-4 text-color-6 tracking-tight mb-4">{t("key_questions_title")}</h2>
            <p className="mb-6">
              <ul className="list-disc pl-6 body-large-8 text-color-7 tracking-[1px]">
                <li>
                {t("key_question_1")}

                </li>
                <li>{t("key_question_2")}</li>
              </ul>
            </p>

            {/* Tauken AI Solution Section */}
            <h2 className="web-heading-main-4 text-color-6 tracking-tight mb-4">{t("how_t_pulse_works_title")}</h2>
            <p className="mb-6">
              <ul className="list-disc pl-6 body-large-8 text-color-7 tracking-[1px]">
                <li>
               {t("how_t_pulse_works_description")}

                </li>

              </ul>
            </p>
          </div>
        </div>

        {/* Product Developer & Image Section */}
        <div className="mt-8 flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          {/* Text Content */}
          <div className="md:w-1/2 space-y-6">
            <h2 className="web-heading-main-4 text-color-6 tracking-tight mb-4">{t("product_developer_title")}</h2>
            <p className="mb-6 body-large-8 text-color-7 tracking-[1px]">
              {t("product_developer_description")}
            </p>
            <h2 className="web-heading-main-4 text-color-6 tracking-tight mb-4">{t("detect_title")}</h2>

            <h3 className="web-heading-main-5 text-color-6 tracking-tight mb-2">{t("product_description_title")}</h3>
            <p className="mb-6 body-large-9 text-color-7 tracking-[1px]">
             .{t("product_description_details")}
            </p>

          </div>

          {/* Image Section */}
          <div className="md:w-1/2 flex justify-center mt-8 md:mt-0 relative " >
            {/* Ellipse in the background */}
            <img
              src="/assets/ellipse.svg"
              className="absolute top-0 bottom-20 h-fit left-1/2 transform -translate-x-1/2 z-[-1] max-w-full h-auto"
              alt="ellipse decoration"
            />
            {/* Solution image with luminosity blend mode applied */}
            <img
              src="/assets/safetymanagement.svg"
              className="max-w-full h-auto mix-blend-luminosity"
              alt="sample detail"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetySection;